export const PLATEFORM: Record<string, string> = {
  isAndroid: "Android",
  isIos: "iOS",
  isWeb: "Web",
};
